// export let baseUrl = "https://ziggsmsbackend.onrender.com";
// export let baseUrl = "https://ziggapp.in";
// export const baseUrl = "http://192.168.1.5:4005";
// export let baseUrl = "http://localhost:4006";
// export let baseUrl = "http://167.71.232.245:4006";
// export let baseUrl = "http://159.89.146.245:4006";
export let baseUrl = "https://v2.ziggapp.in";

export const API = {
  plan: {
    addPlan: "/plan/addPlan",
    deletePlan: "/plan/deletePlanById/",
    getPlanByCreator: "/plan/getPlanByCreator/",
    getPlanById: "/plan/getPlanById/",
    bulkInsertPlan: "/plan/bulkInsertPlan",
    statusChanges: "/plan/updatePlanStatus/",
    getAllChannel: "/channel/getAllChannel",
    deleteChannel: "/channel/deleteChannel/",
    // getAllChannelByCategory: "/channel/getAllChannelByCategory",
    getchannelCategory: "/channel/getCategories",
    addCategory: "/channel/addCategory",
    updateCategory: "/channel/updateCategory/",
    deleteCategory: "/channel/deleteCategory/",
    addChannel: "/channel/addChannel",
    // channelByFilter: "/channel/getChannelByFilter",
    getAllPlans: "/plan/getAllPlans",
    getAllChannelByCategory: "/channel/getAllChannelByCategory",
    getChannelById: "/channel/getChannelById/",
    updateChannelById: "/channel/updateChannel/",
    updatePlan: "/plan/updatePlanById",
    updateSeq: "/channel/updateSeq",
  },
  user: {
    addUser: "/ispMember/addMember",
    getAllUser: "/ispMember/getAllIspMember",
    getUserById: "/ispMember/getMemberById/",
    deleteUser: "/ispMember/deleteIspMember/",
    updateUser: "/ispMember/updateMember/",
    updateMemberStatus: "/ispMember/updateMemberStatus/",
    uploadFile: "/upload/uploadDocuments",
  },

  subscriberManagement: {
    addSubscriber: "/subscriber/addNewConnection",
    getAllSubscriber: "/newSubscriber/getAllSubscriber",
    deleteNewSubscriber: "/newSubscriber/deleteNewSubscriber/",
    getSubscriberById: "/subscriber/getSubscriberById/",
    updateSubscriber: "/subscriber/updateSubscriber/",
    deleteSubscriber: "/subscriber/deleteSubscriberById/",
    updateSubscriberStatus: "/subscriber/updateStatusById/",
    updatePackage: "/newSubscriber/updatePackageById/",
    getSubscriberByNumber: "/newSubscriber/getSubscriberByNumber",
    setSubscriptionManagement: "/newSubscriber/setSubscriptionManagement/",
    updateSecurityStatus: "/newSubscriber/updateSecurityStatus",
    overrideDevice: "/newSubscriber/overrideDevice",
    resetDevice: "/newSubscriber/resetDevice",
  },
  securityCheckManagement: { getSecurityStatus: "/securityCheck/status" },
  invoice: {
    addInvoices: "/invoice/addInvoice",
    getInvoiceById: "/invoice/getInvoiceByCreator/",
    viewDetailInvoice: "/invoice/getInvoiceById/id",
    getInvoicePdfById: "/invoice/getInvoiceById/",
  },
  role: {
    addRole: "/role/superAdmin/addRole",
    getAllRole: "/role/superAdmin/getAllRoleData",
    deleteRole: "/role/superAdmin/deleteRole/",
    updatePermission: "/role/superAdmin/updateRolePermissionById/",
    getRoleDatabyId: "/role/getRoleDatabyId/",
    getPermissionsByRole: "/role/superAdmin/getPermissionByRole",
  },
  auth: {
    login: "/auth/login",
    forgetPassword: "/auth/forgetPassword",
    changePassword: "/auth/changePassword",
    checkUserTokenIsValid: "/auth/checkUserTokenIsValid",
    SendOtp: "/auth/sendOtp",
    VerifyOtp: "/auth/verifyOtp",
  },
  admin: {
    loginSuperAdmin: "/admin/loginSuperAdmin",
  },
  logs: {
    getEventLogsAll: "/log/getEventLogsAll",
  },
  document: {
    upload: "/upload/uploadDocuments",
    deleteDocs: "/upload/deleteMultipleDocData",
  },
  language: {
    allLanguage: "/language/getAllLanguages",
    addLanguage: "/language/addLanguage",
    updateLanguage: "/language/updateLanguageById/",
    deleteLanguage: "/language/deleteLanguageById/",
  },

  genre: {
    allGenre: "/genre/getAllgenre",
    addGenre: "/genre/addgenre",
    updateGenre: "/genre/updategenreById/",
    deleteGenre: "/genre/deletegenreById/",
  },

  broadcaster: {
    getAllBroadcaster: "/broadcaster/getAllBroadcaster",
    addBroadcaster: "/broadcaster/addBroadcaster",
    updateBroadcaster: "/broadcaster/updateBroadcaster/",
    deletBroadcaster: "/broadcaster/deleteBroadcaster/",
  },
  banner: {
    addBanner: "/banner/addBanner",
    updateBanner: "/banner/editBanner/",
    getBanners: "/banner/getAllBanner",
    deleteBanner: "/banner/deleteBanner/",
    updateAppBanner: "/banner/app/updateBanner/",
    getAppBanners: "/banner/app/getAllBanner",
    deleteAppBanner: "/banner/app/deleteBanner/",
    // new
    addPlatFormBanner: "/banner/app/addBanner/secondary", // we add secondary temp
    getAllPlatFormSliderImages: "/banner/getAllSliderImg/secondary",
    deletePlatFormBanner: "/banner/platform/",
    updatePlatFormBanner: "/banner/platform/",
  },
  package: {
    add: "/plan/addPlan",
    update: "/plan/updatePlanById/",
    delete: "/plan/deletePlanById/",
  },
  policy_condition: {
    addPolicy: "/policy_condition/addAndUpdatePolicy",
    addTeamCondition: "/policy_condition/addAndUpdateTeamCondition",
    getPolicy: "/policy_condition/getPolicy",
    getTeamCondition: "/policy_condition/getTeamCondition",
    getAboutUs: "/policy_condition/getAboutUs",
    addAboutUs: "/policy_condition/addAndUpdateAboutUs",
  },
  adBanners: {
    getTVBanners: "/banner/getAllAdvBanner",
    getAppBanners: "/banner/app/getAllAdvAppBanner",
    createAdsBanner: "/ads-banner/createAdsBanner",
    getAllAdsBanners: "/ads-banner/getAllAdsBanners",
  },
  // for Channel Category
  channelCategory: {
    addChannelCategory: "/channelCat/channelCategory",
    getChannelCategory: "/channelCat/channelCategory",
    updateChannelCategory: "/channelCat/channelCategory/",
    deleteChannelCategory: "/channelCat/channelCategory/",
  },

  // for free live channels
  freeLiveChannel: {
    getFreeLiveChannel: "/freeChannel/liveChannel?notFilter=false",
    addFreeLiveChannel: "/freeChannel/liveChannel",
    updateFreeLiveChannel: "/freeChannel/liveChannel/",
    deleteFreeLiveChannel: "/freeChannel/liveChannel/",
  },
  // for App Version
  appVersion: {
    // addChannelCategory: "/channelCat/channelCategory",
    getAppVersion: "/appVersion/detail",
    updateAppVersion: "/appVersion/create",
    // deleteChannelCategory: "/channelCat/channelCategory/",
  },

  // for App Version Mobile
  appVersionMobile: {
    getAppVersionMobile: "/appVersionMobile/detail",
    updateAppVersionMobile: "/appVersionMobile/create",
  },

  // =========================== for channel languages Saket ====================================================

  channelLanguage: {
    createChannelLanguage: "/freeChannelLanguage/addLanguage",
    getAllChannelLanguage: "/freeChannelLanguage/getAllLanguages",
    updateChannelLanguage: "/freeChannelLanguage/updateLanguageById",
    deleteChannelLanguage: "/freeChannelLanguage/deleteLanguageById",
  },

  // cms
  cms: {
    getPrivacyPolicy: "/policy_condition/getPolicy",
    getTermAndCondition: "/policy_condition/getTeamCondition",
    getAboutus: "/policy_condition/getAboutUs",
  },

  // Iptv channel
  iptvChannel: {
    createIptvChannel: "/iptvChannel",
    getAllIptvChannel: "/iptvChannel",
    updateIptvChannel: "/iptvChannel",
    deleteIptvChannel: "/iptvChannel",
  },

  // IPTV User Request
  iptvUserRequest: {
    getAllIptvUserRequest: "/iptv_request/all",
  },

  ottContent: {
    addOttContent: "/ottHub/add",
    getAllOttContent: "/ottHub",
    editOttContent: "/ottHub",
    deleteOttContent: "/ottHub",
  },

  dashboard: {
    getDashboardStats: "/dashboard/stats",
  },
};
